<template>
	<div>
		<h4>IC Liquidity Fund</h4>
		<p>IC Asset Managers (Ghana) LTD, brings you the IC Liquidity Fund (ICLF), an open-ended money market mutual fund which invests primarily in highly liquid assets.</p>

		<p>ICLF seeks to maximise short-term income while ensuring immediate liquidity by investing exclusively in fixed income securities issued by Government of Ghana and its agencies and licensed universal banks in Ghana.</p>

		<p>Download the <a href="https://shorturl.at/lozS9" target="_blank">prospectus</a> for further details</p>
	</div>
</template>

<script>
export default {}
</script>

<style>
</style>